/**
 * Marca Provalia y tonos derivados del color de acento de cada cliente.
 *
 * El acento lo elige el cliente y puede ser cualquier color: un oro como el
 * de Provalia no admite texto blanco encima y, como texto sobre blanco, no se
 * lee. De él se sacan tres tonos que sí cumplen el contraste mínimo de WCAG
 * AA (4,5:1) y la interfaz y los correos usan esos, nunca el acento a pelo
 * para texto.
 */
export const PROVALIA_COLORS = {
    gold: '#D4901A',
    goldLight: '#E7A33A',
    bronze: '#6F411D',
    graphite: '#2A282B',
    cream: '#F9F6F1',
};
/** Color de acento de un cliente que todavía no ha elegido el suyo. */
export const DEFAULT_ACCENT = PROVALIA_COLORS.gold;
const HEX = /^#[0-9a-fA-F]{6}$/;
const WHITE = '#ffffff';
/** Superficie de las tarjetas en modo oscuro (shared/styles.css). */
const DARK_SURFACE = '#252326';
const AA = 4.5;
function toRgb(hex) {
    const n = Number.parseInt(hex.slice(1), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function toHex([r, g, b]) {
    return '#' + [r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('');
}
function luminance(hex) {
    const [r, g, b] = toRgb(hex).map((v) => {
        const c = v / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export function contrast(a, b) {
    const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
    return (hi + 0.05) / (lo + 0.05);
}
/** Mezcla `hex` con `toward` en pasos hasta contrastar con `bg`. */
function shiftUntilReadable(hex, toward, bg) {
    const from = toRgb(hex);
    const to = toRgb(toward);
    for (let i = 0; i <= 20; i++) {
        const t = i / 20;
        const c = toHex(from.map((v, k) => v + (to[k] - v) * t));
        if (contrast(c, bg) >= AA)
            return c;
    }
    return toward;
}
export function accentTones(accent) {
    const a = HEX.test(accent) ? accent : DEFAULT_ACCENT;
    const graphite = PROVALIA_COLORS.graphite;
    return {
        ink: contrast(WHITE, a) >= contrast(graphite, a) ? WHITE : graphite,
        textLight: shiftUntilReadable(a, '#000000', WHITE),
        textDark: shiftUntilReadable(a, WHITE, DARK_SURFACE),
    };
}
//# sourceMappingURL=brand.js.map